<template>
  <div class="header-link-container">
    <HeaderButton @click.native="goToStoreClick">
      <template v-slot:btn>
        <GoToStore />
      </template>
    </HeaderButton>
    <HeaderButton @click.native="playNowClick">
      <template v-slot:btn>
        <PlayNow />
      </template>
    </HeaderButton>
  </div>
</template>

<script>
import HeaderButton from "./components/headerButton";
import responsiveMixin from "@/mixins/responsive";
import GoToStore from "./components/goToStore/index.vue";
import PlayNow from "./components/playNow/index.vue";

export default {
  name: "HeaderLink",
  mixins: [responsiveMixin],
  data() {
    return {
      isScrolled: false
    }
  },
  props: {},
  components: {
    HeaderButton,
    GoToStore,
    PlayNow
  },
  computed: {},
  mounted() { },
  methods: {
    goToStoreClick() {
      const externalLink = "https://matr1x.io/launcher";
      window.location.href = externalLink;
    },
    playNowClick() {
      const internalLink = "/home";
      this.$router.push(internalLink);
    }
  },
}
</script>

<style lang="scss" scoped>
@import "./headerLink.scss";
</style>